var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-popup',{staticClass:"lesson-popup",attrs:{"title":"","active":_vm.popupActive},on:{"update:active":function($event){_vm.popupActive=$event}}},[(_vm.lesson)?_c('div',{staticClass:"min-h-full"},[_c(_vm.lesson.name,{tag:"component",attrs:{"lesson":_vm.lesson},on:{"hidePopup":function($event){_vm.popupActive=false}}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }